export const CimplifiCustomGraphic = () => {
  const area = $(".cimplifi-custom-graphic");
  const images = area.children();
  const triggers = $(".cimplifi-graphic-areas").children();

  triggers.on("mouseover", (e) => {
    const el = $(e.delegateTarget);
    const target = "." + el.data("target");
    images.css({ opacity: 0 });
    area.find(target).css({ opacity: 1 });
  });

  triggers.on("mouseleave", (e) => {
    images.css({ opacity: 0 });
    images.first().css({ opacity: 1 });
  });
};
